import {
    FETCH_DEVICES_LIST,
    FETCH_DEVICES_LIST_SUCCESS,
    FETCH_DEVICES_LIST_FAILED,
    FETCH_USER_DETAILS,
    FETCH_USER_DETAILS_SUCCESS,
    FETCH_USER_DETAILS_FAILED,
    UPDATE_USER_DETAILS,
    UPDATE_USER_DETAILS_SUCCESS,
    UPDATE_USER_DETAILS_FAILED,
    FETCH_AVAILABLE_DEVICES,
    FETCH_AVAILABLE_DEVICES_SUCCESS,
    FETCH_AVAILABLE_DEVICES_FAILED,
    FETCH_USER_COUNTRIES,
    FETCH_USER_COUNTRIES_SUCCESS,
    FETCH_USER_COUNTRIES_FAILED,
    GET_LIST_OF_SPECIALISATION,
    GET_LIST_OF_SPECIALISATION_SUCCESS,
    GET_LIST_OF_SPECIALISATION_FAILED,

    DEVICE_OPERATION,
    DEVICE_OPERATION_SUCCESS,
    DEVICE_OPERATION_FAILED,
    RESET_DEVICE_OPERATION_RESPONSE,

    DEPLOY_DEVICE_IN_PAST_DATE,
    DEPLOY_DEVICE_IN_PAST_DATE_SUCCESS,
    DEPLOY_DEVICE_IN_PAST_DATE_FAILED,

    FETCH_DEVICE_HISTORY,
    FETCH_DEVICE_HISTORY_SUCCESS,
    FETCH_DEVICE_HISTORY_FAILED,

    FETCH_AVAILABLE_DEVICES_DATES,
    FETCH_AVAILABLE_DEVICES_DATES_SUCCESS,
    FETCH_AVAILABLE_DEVICES_DATES_FAILED,

    FETCH_FUTURE_ALLOCATIONS,
    FETCH_FUTURE_ALLOCATIONS_SUCCESS,
    FETCH_FUTURE_ALLOCATIONS_FAILED,

    CANCEL_FUTURE_ALLOCATIONS,
    CANCEL_FUTURE_ALLOCATIONS_SUCCESS,
    CANCEL_FUTURE_ALLOCATIONS_FAILED,

    FETCH_LIVE_DEVICES,
    FETCH_LIVE_DEVICES_SUCCESS,
    FETCH_LIVE_DEVICES_FAILED,

    RESET_PATIENT_PASSWORD,
    RESET_PATIENT_PASSWORD_SUCCESS,
    RESET_PATIENT_PASSWORD_FAILED,
    RESET_PATIENT_PASSWORD_STATE,
    RESET_UPDATE_USER_DETAILS,
    RESET_DEPLOY_DEVICE_IN_PAST_DATE
} from "constants/ActionTypes";

export const fetch_user_details = () => ({
    type: FETCH_USER_DETAILS
});

export const fetch_user_details_success = payload => ({
    type: FETCH_USER_DETAILS_SUCCESS,
    payload
});

export const fetch_user_details_failed = error => ({
    type: FETCH_USER_DETAILS_FAILED,
    error
});

export const fetch_devices_list = () => ({
    type: FETCH_DEVICES_LIST
});

export const fetch_devices_list_success = payload => ({
    type: FETCH_DEVICES_LIST_SUCCESS,
    payload
});

export const fetch_devices_list_failed = error => ({
    type: FETCH_DEVICES_LIST_FAILED,
    error
});
export const update_user_info = payload => {
    // alert(JSON.stringify(payload));
    return {
        type: UPDATE_USER_DETAILS,
        payload
    };
};
export const update_user_info_success = payload => {
    return {
        type: UPDATE_USER_DETAILS_SUCCESS,
        payload
    };
};
export const update_user_info_failed = error => {
    return {
        type: UPDATE_USER_DETAILS_FAILED,
        error
    };
};
export const reset_user_update_details = (payload) => {
    return {
        type: RESET_UPDATE_USER_DETAILS,
        payload
    }
}

export const fetch_available_devices = payload => ({
    type: FETCH_AVAILABLE_DEVICES,
    payload
});

export const fetch_available_devices_success = payload => ({
    type: FETCH_AVAILABLE_DEVICES_SUCCESS,
    payload
});

export const fetch_available_devices_failed = error => ({
    type: FETCH_AVAILABLE_DEVICES_FAILED,
    error
});

export const fetch_user_countries = () => ({
    type: FETCH_USER_COUNTRIES
});

export const fetch_user_countries_success = payload => ({
    type: FETCH_USER_COUNTRIES_SUCCESS,
    payload
});

export const fetch_user_countries_failed = error => ({
    type: FETCH_USER_COUNTRIES_FAILED,
    error
});

export const get_list_of_specialisation = () => ({
    type: GET_LIST_OF_SPECIALISATION
});

export const get_list_of_specialisation_success = payload => ({
    type: GET_LIST_OF_SPECIALISATION_SUCCESS,
    payload
});

export const get_list_of_specialisation_failed = error => ({
    type: GET_LIST_OF_SPECIALISATION_FAILED,
    error
});

export const device_operation = payload => ({
    type: DEVICE_OPERATION,
    payload
});

export const device_operation_success = data => ({
    type: DEVICE_OPERATION_SUCCESS,
    data
});

export const reset_device_operation_response = () => ({
    type: RESET_DEVICE_OPERATION_RESPONSE
})
export const reset_past_device_deployment = () => ({
    type: RESET_DEPLOY_DEVICE_IN_PAST_DATE

})

export const reset_patient_password_state = () => ({
    type: RESET_PATIENT_PASSWORD_STATE
})

export const reset_patient_password = payload => ({
    type: RESET_PATIENT_PASSWORD,
    payload
});

export const reset_patient_password_success = data => ({
    type: RESET_PATIENT_PASSWORD_SUCCESS,
    data
});

export const reset_patient_password_failed = error => ({
    type: RESET_PATIENT_PASSWORD_FAILED,
    error
});

export const device_operation_failed = error => ({
    type: DEVICE_OPERATION_FAILED,
    error
});

export const deploy_device_in_past_date = payload => ({
    type: DEPLOY_DEVICE_IN_PAST_DATE,
    payload
});

export const deploy_device_in_past_date_success = data => ({
    type: DEPLOY_DEVICE_IN_PAST_DATE_SUCCESS,
    data
});

export const deploy_device_in_past_date_failed = error => ({
    type: DEPLOY_DEVICE_IN_PAST_DATE_FAILED,
    error
});

export const fetch_device_history = payload => ({
    type: FETCH_DEVICE_HISTORY,
    payload
})

export const fetch_device_history_success = data => ({
    type: FETCH_DEVICE_HISTORY_SUCCESS,
    data
})

export const fetch_device_history_failed = error => ({
    type: FETCH_DEVICE_HISTORY_FAILED,
    error
})

export const fetch_available_devices_dates = () => ({
    type: FETCH_AVAILABLE_DEVICES_DATES
})

export const fetch_available_devices_dates_success = data => ({
    type: FETCH_AVAILABLE_DEVICES_DATES_SUCCESS,
    data
})

export const fetch_available_devices_dates_failed = error => ({
    type: FETCH_AVAILABLE_DEVICES_DATES_FAILED,
    error
})

export const fetch_future_allocations = payload => ({
    type: FETCH_FUTURE_ALLOCATIONS,
    payload
})

export const fetch_future_allocations_success = data => ({
    type: FETCH_FUTURE_ALLOCATIONS_SUCCESS,
    data
})

export const fetch_future_allocations_failed = error => ({
    type: FETCH_FUTURE_ALLOCATIONS_FAILED,
    error
})

export const cancel_future_allocations = payload => ({
    type: CANCEL_FUTURE_ALLOCATIONS,
    payload
})

export const cancel_future_allocations_success = data => ({
    type: CANCEL_FUTURE_ALLOCATIONS_SUCCESS,
    data
})

export const cancel_future_allocations_failed = error => ({
    type: CANCEL_FUTURE_ALLOCATIONS_FAILED,
    error
})

export const fetch_live_devices = (payload) => ({
    type: FETCH_LIVE_DEVICES,
    payload
})

export const fetch_live_devices_success = data => ({
    type: FETCH_LIVE_DEVICES_SUCCESS,
    data
})

export const fetch_live_devices_failed = error => ({
    type: FETCH_LIVE_DEVICES_FAILED,
    error
})